import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AyenMapModule } from 'ayen-google-map';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { PropertyUnitsRoutingModule } from './property-units-routing.module';
import { PropertyUnitsComponent } from './pages/property-units/property-units.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { PropertyUnitDetailsComponent } from './pages/property-unit-details/property-unit-details.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';
import { GoogleMapsModule } from '@angular/google-maps';
import { EditPropertyUnitComponent } from './pages/edit-property-unit/edit-property-unit.component';
import { AddUnitFileComponent } from './components/add-unit-file/add-unit-file.component';
import { PropertyUnitLocationComponent } from './components/property-unit-location/property-unit-location.component';
import { UnitDetailsComponent } from './components/unit-details/unit-details.component';
import { AddPropertyUnitComponent } from './components/add-property-unit/add-property-unit.component';

@NgModule({
  declarations: [
    PropertyUnitsComponent,
    EditPropertyUnitComponent,
    PropertyUnitDetailsComponent,
    PropertyUnitLocationComponent,
    AddUnitFileComponent,
    UnitDetailsComponent,
    AddPropertyUnitComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AyenMapModule,
    NgSelectModule,
    PropertyUnitsRoutingModule, 
    SharedModule, 
    MatExpansionModule,
    MatDialogModule,
    GoogleMapsModule
  ],
  exports: [
    AddPropertyUnitComponent
  ]
})
export class PropertyUnitsModule {}
